// Test IDs for the client account dashboard (/account).

export const CLIENT_DASHBOARD = {
  page: 'client-dashboard-page',
  tabNewOrder: 'client-tab-new-order',
  tabMyOrders: 'client-tab-my-orders',
  ordersTable: 'client-orders-table',
  logoutButton: 'client-logout-button',
  navLink: 'navbar-client-login-link',
  footerNavLink: 'footer-client-login-link',
  mobileNavLink: 'mobile-client-login-link',
};
